import api from './index'

/**
 * 获取会话记录
 * @param {*} data
 * @returns
 */
export const getRecordList = (data) => {
  return api({ url: '/admin/tinree/log', data })
}
/**
 * 获取总条数
 * @param {*} data
 * @returns
 */
export const getCount = (data) => {
  return api({ url: '/admin/tinree/statistical', data })
}

/**
 * 获取短信签名列表
 * @param {*} data
 * @returns
 */
export const getSignList = (data) => {
  return api({ url: '/admin/tinree/sign/list', data })
}
/**
 * 添加签名
 * @param {*} data
 * @param {*} type
 * @returns
 */
export const addSign = (data, type) => {
  return api({
    url: `/admin/tinree/sign/${type ? 'add' : 'edit'}`,
    method: 'post',
    data,
  })
}
/**
 * 删除签名
 * @param {*} data
 * @returns
 */
export const deleteSign = (data) => {
  return api({ url: '/admin/tinree/sign/del', method: 'post', data })
}
/**
 * 获取模板列表
 * @param {*} data
 * @returns
 */
export const getTemplateList = (data) => {
  return api({ url: '/admin/tinree/template/list', data })
}
/**
 * 增加模板
 * @param {*} data
 * @param {*} type
 * @returns
 */
export const addTemplate = (data, type) => {
  return api({
    url: `/admin/tinree/template/${type ? 'add' : 'edit'}`,
    method: 'post',
    data,
  })
}
/**
 * 删除模板
 * @param {*} data
 * @returns
 */
export const deleteTemplate = (data) => {
  return api({ url: '/admin/tinree/template/del', method: 'post', data })
}

/**
 * 获取短信配置列表
 * @param {*} data
 * @returns
 */
export const getSettingList = (data) => {
  return api({ url: '/admin/tinree/config/list', data })
}

/**
 * 新增或修改的短信配置
 * @param {*} data
 * @returns
 */
export const addSetting = (data) => {
  return api({ url: '/admin/tinree/config/post', method: 'post', data })
}

/**
 * 获取小程序路径
 * @returns
 */
export const getAppUrl = () => {
  return api({ url: '/admin/tinree/applet' })
}
/**
 * 获取短信秘钥
 * @returns
 */
export const getAccessKey = () => {
  return api({ url: '/admin/tinree/sms' })
}

/**
 * 保存短信秘钥
 * @param {*} data
 * @returns
 */
export const saveAccessKey = (data) => {
  return api({ url: '/admin/tinree/sms/key', method: 'post', data })
}
